import React from 'react';
import { NativeSelect, Select as FSelect } from '@folksam/ui-next/components';

import FormField from '../components/FormField';

export const Select = ({ label, meta, ...props }) => {
    return (
        <FormField
            label={label}
            meta={meta}
            id={props.fieldId}
            component={props.disabled || props.children.length > 100 ? NativeSelect : FSelect}
            inputProps={{ ...props, css: { height: 'initial' } }}
        />
    );
};
export const SelectOption = FSelect.Option;
